import { render, staticRenderFns } from "./BulkSuspendTwilioAccounts.vue?vue&type=template&id=12d744a8&scoped=true&"
import script from "./BulkSuspendTwilioAccounts.vue?vue&type=script&lang=js&"
export * from "./BulkSuspendTwilioAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BulkSuspendTwilioAccounts.vue?vue&type=style&index=0&id=12d744a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d744a8",
  null
  
)

export default component.exports